import { useEffect, useRef } from "react";

/**
 * Runs an effect only after the initial mount.
 * @param {Function} effect - effect function
 * @param {Array} deps - dependency array
 */
const useEffectAfterMount = (effect, deps) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // skip effect on first render
    }
    return effect(); // run normally after first render
  }, deps);
};

export default useEffectAfterMount;